<template>
  <div class="root">
    <v-flex xs12 pt-2>
      <draggable
        style="width: 100%; min-height: 10px;"
        v-model="tasklists"
        :ghost="true"
      >
        <task-template-list
          v-for="(tasklist, index) in tasklists" :key="tasklist.id" :index="index"
          collection="lists"
          :tasklist="tasklist"
          :position="index"
          :caseType="caseType"
          v-on:tasklist-remove="removeTasklist(tasklist)">
        </task-template-list>
      </draggable>
    </v-flex>
  </div>
</template>

<script>
import TaskTemplateList from "./TaskTemplateList.vue"
import draggable from "vuedraggable"
import Helpers from "@/helpers.js"
import { mapState } from 'vuex'

export default {
  name: "TasklistTemplateList",
  components: { TaskTemplateList, draggable },
  computed: {
    noTasklists() {
      return this.tasklists.length
    },
    ...mapState({
      caseType: state => state.caseTypes.current,
      tasklistTemplates: state =>
        state.caseTypes.current &&
        state.caseTypes.current.tasklistTemplates
          ? state.caseTypes.current.tasklistTemplates
          : []
    }),
    tasklists: {
      get() {
        if (this.tasklistTemplates) {
          Helpers.orderItemsByPosition(this.tasklistTemplates)
          return this.tasklistTemplates
        } else {
          return []
        }
      },
      set(tasklists) {
        Helpers.updateItemPositions(tasklists)
      }
    }
  },
  methods: {
    removeTasklist(tasklist) {
      this.$emit("tasklist-remove", tasklist)
    }
  }
}

</script>
